import { makeStyles } from "tss-react/mui";

const useDialogStyles = makeStyles()((theme) => ({
  contentRoot: {
    "& .MuiDialog-paper": {
      margin: "10px",
      overflowX: "hidden",
      backgroundColor: theme.palette.surface.light,
    },
    "& .MuiDialog-paperFullWidth": {
      width: "calc(100% - 20px)",
    },
    "& .MuiDialogContent-root": {
      padding: "8px",
      paddingTop: "8px !important",
    },
  },
  grey: {
    "& .MuiDialog-paper": {
      backgroundColor: theme.palette.surface.bg,
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
    },
    "& .MuiDialogActions-root": {
      backgroundColor: theme.palette.surface.light,
    },
  },
  title: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%",
    display: "inline-block",
    fontSize: "18px",
    fontWeight: "400",
  },
  dialogTitle: {
    paddingTop: "5px",
    paddingBottom: "0px",
  },
  dialogTitleSmallScreen: {
    padding: "5px 8px 0 8px",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  icon: {
    color: theme.palette.text.primary,
  },
  cancelButton: {
    textAlign: "center",
    fontSize: "0.9375rem",
    backgroundColor: theme.palette.surface.light,
  },
}));

export default useDialogStyles;
